<template>
    <fb-form-body>

        <el-form :model="formData" :rules="rules" ref="form" label-width="100px">


            <el-form-item label="文章标题" prop="title" :error="formErrorMsg.title" class="fb-form-item">
                <el-input v-model="formData.title" placeholder="文章标题"></el-input>
            </el-form-item>

            <el-form-item label="文章副标题" prop="subTitle" :error="formErrorMsg.subTitle" class="fb-form-item">
                <el-input v-model="formData.subTitle" placeholder="文章副标题"></el-input>
            </el-form-item>


            <el-form-item label="文章分类" prop="category" :error="formErrorMsg.category" class="fb-form-item">
                <cms-category-select v-model="formData.category" flag="VIDEO" disabled></cms-category-select>
            </el-form-item>


            <el-form-item label="视频类型" prop="type" :error="formErrorMsg.type" class="fb-form-item">
                <el-radio v-model="formData.type" label="1">普通</el-radio>
                <el-radio v-model="formData.type" label="2">外链</el-radio>
            </el-form-item>

            <el-form-item v-if="formData.type === '2'" label="视频外链" prop="videoLink" :error="formErrorMsg.videoLink" class="fb-form-item">
                <el-input v-model="formData.videoLink" placeholder="视频外链"></el-input>
            </el-form-item>

            <el-form-item v-if="formData.type === '1'" label="文章内容" prop="content" :error="formErrorMsg.content" >
               <wangeditor v-model="formData.content" :upload-img-server="$api.cmsArticle.upload"></wangeditor>
            </el-form-item>

            <el-form-item v-if="formData.type === '1'" label="摘要" prop="description" :error="formErrorMsg.description" class="fb-form-item">
                <el-input v-model="formData.description" placeholder="摘要"></el-input>
            </el-form-item>


            <el-form-item v-if="formData.type === '1'" label="视频" prop="refVideo" :error="formErrorMsg.refVideo" class="fb-form-item">
                <single-video-uploader v-model="formData.refVideo" category="ART_VIDEO"></single-video-uploader>
            </el-form-item>


            <el-form-item label="语言" prop="lang" :error="formErrorMsg.lang" class="fb-form-item">
                <dict-select type-flag="LANG" v-model="formData.lang"></dict-select>
            </el-form-item>


            <el-form-item label="排序" prop="sortNum" :error="formErrorMsg.sortNum" class="fb-form-item">
                <el-input v-model="formData.sortNum" placeholder="排序"></el-input>
            </el-form-item>



            <el-form-item>
                <el-button type="primary" @click="handleSubmit('form')">确定</el-button>
                <el-button @click="handleReset('form')">重置</el-button>
            </el-form-item>
        </el-form>
    </fb-form-body>
</template>

<script>


    import SinglePicUploader from "../../components/SinglePicUploader";
    import CmsCategorySelect from "../../components/CmsCategorySelect";
    import Wangeditor from "../../components/Wangeditor";
    import SingleVideoUploader from "../../components/SingleVideoUploader";

    export default {
        name: "PartnerAdd",
        components: {SingleVideoUploader, Wangeditor, CmsCategorySelect},
        data() {
            return {

                api: {
                    add: this.$api.cmsArticle.add
                },
                formErrorMsg: {
                    title: '',
                    subTitle: '',
                    cover: '',
                    sortNum: '',
                    content: '',
                    category: '',
                    keywords:'',
                    description:'',
                    firstPic:"",
                    publishTime:"",
                    refVideo:"",
                    type:"",
                    videoLink:''
                },
                formData: {
                    title: '',
                    subTitle: '',
                    cover: '',
                    sortNum: '',
                    content: '',
                    category: '',
                    keywords:'',
                    description:'',
                    firstPic:"",
                    publishTime:"",
                    refVideo:"",
                    type:"1",
                    videoLink:'',
                    lang:'en'

                },
                rules: {
                    title: [
                        {required: true, message: '文章标题不能为空', trigger: 'blur'},
                    ],
                    category: [
                        {required: true, message: '请选择文章分类', trigger: 'blur'},
                    ],lang: [
                        {required: true, message: '请选择语言类型', trigger: 'blur'},
                    ]
                }
            }
        },
        methods: {
            handleSubmit(form) {

                let vm = this;
                vm.$refs[form].validate((valid) => {
                    if (valid) {
                        vm.$http.post(vm.api.add, vm.$qs.stringify(this.formData)).then((resp) => {

                            if (resp.data.status === 200) {
                                vm.$message({
                                    type: 'success',
                                    message: resp.data.desc
                                });
                                vm.$router.cgBack();
                            } else if (resp.data.status === 400) {

                                console.log(vm.$refs[form]);


                                resp.data.data.errorFields.forEach(function (a) {

                                    vm.formErrorMsg[a.name] = '';
                                    vm.$nextTick(() => {
                                        vm.formErrorMsg[a.name] = a.message;
                                    });


                                });

                                if (resp.data.desc) {
                                    vm.$message({
                                        type: "error",
                                        message: resp.data.desc
                                    });
                                }


                            } else {
                                vm.$message({
                                    type: "error",
                                    message: resp.data.desc
                                })
                            }

                        });
                        return true;
                    } else {
                        return false;
                    }
                });

            },
            handleReset(form) {
                this.$refs[form].resetFields();
            }
        },
        created() {
            if (this.$route.query.parent) {
                this.formData.parent = this.$route.query.parent
            }
        }
    }
</script>

<style lang="scss" scoped>

    .fb-form-item {
        max-width: 500px;
    }


</style>


<style>
    .editor-item > .el-form-item__content {
        line-height: initial !important;
    }
</style>